import { useContext } from 'react';
import CurrentUserPermissionsContext from 'src/utils/context/CurrentUserPermissionsContext';
import { AUTH_TOKEN_KEY } from './constants';
import { tokenChanged } from './event';
import { encode, decode } from './crypt';

const setAuthToken = token =>
  window.localStorage.setItem(AUTH_TOKEN_KEY, encode(token));
const getAuthToken = () => decode(window.localStorage.getItem(AUTH_TOKEN_KEY));
const removeAuthToken = () => window.localStorage.removeItem(AUTH_TOKEN_KEY);

// like a shortcut
const authToken = token => {
  if (token === undefined) return getAuthToken();
  const authorized = getAuthToken();
  const method = token === null ? removeAuthToken : setAuthToken;
  const value = method(token);
  const invalidToken = !authorized?.user && token?.user; // invalid when user object is not present in the token stored in local storage
  if(invalidToken || !token) {
    tokenChanged(token);
  }
  return value;
};

export const userAuthorization = () => {
  const { compact: permissions } = useContext(CurrentUserPermissionsContext);
  const roles = authToken()?.user?.roles?.map(r => r.name);

  return roles ? {
    isAuditor: roles.includes('Auditor'),
    isReportReviewer: permissions.has('ReportReview', 'change'),
    isCapManager: roles.includes('CAP Manager'),
    isSaqManager: roles.includes('SAQ Manager'),
    isCapManagerRead: permissions.has('CAP', 'read'),
    isClientUser: roles.includes('Client User'),
    isFactoryUser: roles.includes('Factory user'),
    isVendorUser: roles.includes('Vendor user'),
    isMasterDataManager: permissions.has('MasterData', 'change'),
    isAdmin: roles.includes('Admin'),
    isSurveyManager: permissions.has('Survey', 'read'),
    hasMultipleRoles: roles.length > 1,
  } : {};
};

export default authToken;
